import React from 'react';
import { useTranslation } from 'react-i18next';

import type { MyBusinessPanelProps } from '../MyBusinessPanel';
import * as leftBar from '#packages/leftBar';
import { TRANSLATIONS } from '../constants';

export interface PanelFrameOwnProps {
  panelName: string;
  panelIndex: number;
}

type PanelFrameProps = MyBusinessPanelProps & PanelFrameOwnProps;

export const withPanelFrame = (
  Target: React.ComponentType<MyBusinessPanelProps>,
) => {
  const PanelFrameComponent: React.FC<PanelFrameProps> = (props) => {
    const { panelName, panelIndex } = props;
    const [translate] = useTranslation();

    const LeftPanelFrame = leftBar.LeftPanelFrame;

    return (
      <LeftPanelFrame
        panelName={panelName}
        panelIndex={panelIndex}
        panelClass={'app-manager-panel-new'}
        label={translate(TRANSLATIONS.PANEL_TITLE)}
      >
        <Target {...props} />
      </LeftPanelFrame>
    );
  };

  return PanelFrameComponent;
};
